import { useSuspenseQuery } from '@tanstack/react-query';
import { loadImage } from '~/utils/loadImage';
import { MINUTE } from '~/constants';

interface SuspenseImageProps {
  url: string;
}

export default function SuspenseImage({ url }: SuspenseImageProps) {
  const { data } = useSuspenseQuery({
    queryKey: [url],
    queryFn: () => loadImage(url),
    staleTime: 30 * MINUTE,
  });

  return <img src={url} alt='character thumbnail' />;
}
